// Адрес бэкенда для фронта.
//
// Раньше в сборку зашивался абсолютный адрес (https://lorus.sts-zao.ru), поэтому
// страница, открытая по внутреннему IP, всё равно ходила на внешний домен: стоило
// пропасть интернету — и терминал оставался без интерфейса, хотя сервер работает
// в той же сети. Пустое значение означает «тот же хост, с которого открыта
// страница», и приложение одинаково работает и снаружи, и по http://192.168.0.222.
//
// В разработке значения остаются абсолютными: там фронт на 5173, а бэкенд на 3000.
export const API_BASE = import.meta.env.VITE_API_URL || ''

// Адрес вебсокета берём из того же хоста и протокола: по https нужен wss, иначе
// браузер откажется открывать незащищённое соединение со страницы по https.
export function cableUrl (token) {
  const configured = import.meta.env.VITE_ACTION_CABLE_URL

  const base = configured ||
    `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/cable`

  return `${base}?token=${token}`
}
